// The admin ships no icon font or icon package, so the assistant draws its own
// glyphs. They are decorative: every control that uses one carries its own
// accessible name.
const base = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
}

export function SparkleIcon(props) {
  return (
    <svg {...base} fill="currentColor" stroke="none" {...props}>
      <path d="M8 1.2l1.5 3.9 3.9 1.5-3.9 1.5L8 12l-1.5-3.9L2.6 6.6l3.9-1.5L8 1.2z" />
      <path d="M12.7 10.2l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7.7-1.8z" />
    </svg>
  )
}

export function ComposeIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M13.6 2.4a1.4 1.4 0 0 1 0 2L7.2 10.8l-2.6.6.6-2.6 6.4-6.4a1.4 1.4 0 0 1 2 0z" />
      <path d="M13.5 9.6v3a1.4 1.4 0 0 1-1.4 1.4H3.4A1.4 1.4 0 0 1 2 12.6V3.9a1.4 1.4 0 0 1 1.4-1.4h3" />
    </svg>
  )
}

export function CloseIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M4 4l8 8M12 4l-8 8" />
    </svg>
  )
}

export function ChevronIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M4.5 6.5L8 10l3.5-3.5" />
    </svg>
  )
}

export function MicIcon(props) {
  return (
    <svg {...base} {...props}>
      <rect x="6" y="1.8" width="4" height="7.4" rx="2" />
      <path d="M3.6 7.4a4.4 4.4 0 0 0 8.8 0M8 11.8v2.4" />
    </svg>
  )
}

export function SpeakerIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M8.4 2.8L5.1 5.4H2.7v5.2h2.4l3.3 2.6V2.8z" />
      <path d="M10.9 6.1a2.9 2.9 0 0 1 0 3.8M12.8 4.2a5.5 5.5 0 0 1 0 7.6" />
    </svg>
  )
}

export function SpeakerOffIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M8.4 2.8L5.1 5.4H2.7v5.2h2.4l3.3 2.6V2.8z" />
      <path d="M11 6.2l3.2 3.6M14.2 6.2L11 9.8" />
    </svg>
  )
}

export function PaperclipIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M5.2 8.7l4.5-4.5a2.1 2.1 0 0 1 3 3l-5.8 5.8a3.3 3.3 0 0 1-4.7-4.7l5.6-5.6" />
    </svg>
  )
}

export function StopIcon(props) {
  return (
    <svg {...base} fill="currentColor" stroke="none" {...props}>
      <rect x="4.5" y="4.5" width="7" height="7" rx="1.4" />
    </svg>
  )
}

export function SendIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M8 13V3.4M8 3.4L4 7.4M8 3.4l4 4" />
    </svg>
  )
}

export function ContextIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M8 14.2s4.6-3.7 4.6-7.3a4.6 4.6 0 1 0-9.2 0c0 3.6 4.6 7.3 4.6 7.3z" />
      <circle cx="8" cy="6.8" r="1.7" />
    </svg>
  )
}

export function InfoIcon(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="8" cy="8" r="6.2" />
      <path d="M8 7.3v3.6M8 5.2v.1" />
    </svg>
  )
}

export function TraceIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M2.8 8h3l1.6-3.6L9.2 11l1.4-3h2.6" />
    </svg>
  )
}
